var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCause4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff305e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,25c-22.09,0-40,25-40,25,0,0,17.91,25,40,25s40-25,40-25c0,0-17.91-25-40-25ZM50,65c-8.28,0-15-6.72-15-15s6.72-15,15-15,15,6.72,15,15-6.72,15-15,15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57,46.5c0,1.93-1.57,3.5-3.5,3.5s-3.5-1.57-3.5-3.5,1.57-3.5,3.5-3.5c.15,0,.3.03.44.04-1.16-.66-2.51-1.04-3.94-1.04-4.42,0-8,3.58-8,8s3.58,8,8,8,8-3.58,8-8c0-1.44-.38-2.78-1.04-3.94.02.15.04.29.04.44Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCause4);
export default __webpack_public_path__ + "static/media/cause_4.a74b9560b2fb75264b3d972749669a3b.svg";
export { ForwardRef as ReactComponent };